// Masonry
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

// Modules
import initFiches from '../modules/fiches';
import initLecteurVideo from '../modules/lecteurVideo';
import initOngletsNav from '../modules/ongletsNav';
import initGrillesDeCours from '../modules/grillesDeCours';
import initNavigationSurPageImage from '../modules/surPageImage';
import initFlickitySliders from '../modules/flickitySliders';
import initAos from './../aos';

const LOADER = `
    <div class="simple-page-loader-wrapper">
        <svg
            class="simple-page-loader"
            width="100"
            viewBox="0 0 38 38"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#1c1c1c"
        >
            <g transform="translate(1 1)" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </path>
            </g>
        </svg>
    </div>
`;

export default function initAlbumsPhotos() {
    // Init
    initAlbumsThumbsScripts();

    // On Load
    const currrentPageHash = window.location.hash;

    if (currrentPageHash) {
        const target = document.querySelector(
            `[data-album-id="${currrentPageHash.replace('#', '')}"]`
        );

        if (!target) {
            return;
        }

        target.click();
    }

    // Methods
    function initAlbumsThumbsScripts() {
        const albumsPhotosThumbnails = document.querySelectorAll(
            '.site-block.block-albums-photos a'
        );
        const mainContainerContentBackup = document.querySelector(
            '[data-barba="container"]'
        ).innerHTML;

        albumsPhotosThumbnails.forEach((album) => {
            album.addEventListener('click', (e) => {
                e.preventDefault();

                // Page main container
                const mainContainer = document.querySelector('[data-barba="container"]');

                // Get album url
                const albumUrl = album.getAttribute('href');
                const albumId = album.getAttribute('data-album-id');

                // Fade out main container
                mainContainer.classList.add('fade-out');

                // Add loader after main container
                mainContainer.insertAdjacentHTML('afterend', LOADER);

                setTimeout(() => {
                    // Scroll to top
                    window.scrollTo(0, 0);
                }, 455);

                // Fetch album content
                fetch(albumUrl)
                    .then((response) => response.text())
                    .then((html) => {
                        // Create a new document
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');

                        // Get album content
                        const albumContent = doc.querySelector('[data-barba="container"]');

                        // Replace main container content
                        mainContainer.innerHTML = albumContent.innerHTML;

                        // Add a back button
                        mainContainer.querySelector('.block-albums-photos').insertAdjacentHTML(
                            'beforebegin',
                            `
                                <div class="site-block site-max-width no-padding">
                                    <a
                                        href="#"
                                        class="site-btn dark small back-btn"
                                        aria-label="Retour à la page précédente"
                                        onclick="window.history.back(); return false;">
                                        <svg
                                            width="16"
                                            height="18"
                                            viewbox="0 0 16 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M6.88522 10.8757L9.66797 8.37122L8.999 7.62793L6.21626 10.1324C5.7013 10.5958
                                                    5.7013 11.4033 6.21626 11.8668L8.999 14.3712L9.66797 13.6279L6.88522
                                                    11.1235C6.81166 11.0573 6.81166 10.9419 6.88522 10.8757Z"
                                                fill="#fff"/>
                                        </svg>
                                        Retour
                                    </a>
                                </div>
                            `
                        );

                        mainContainer.querySelector('.back-btn').addEventListener('click', (e) => {
                            e.preventDefault();

                            // Replace main container content
                            mainContainer.innerHTML = mainContainerContentBackup;

                            setTimeout(() => {
                                // Scroll to album smoothly
                                const newAlbumNode = mainContainer.querySelector(
                                    `[data-album-id="${albumId}"]`
                                );

                                // Get album position from viewport top
                                const newAlbumNodePosition =
                                    newAlbumNode.getBoundingClientRect().top;

                                window.scrollTo({
                                    top: newAlbumNodePosition,
                                    behavior: 'smooth',
                                });

                                // Remove hash from current page url
                                history.pushState(null, null, ' ');

                                initAlbumsThumbsScripts();

                                initPageModulesScripts();
                            }, 255);
                        });

                        // Init album photos
                        setTimeout(() => {
                            initAlbumsGridScripts(mainContainer);
                            initAos();

                            // Window add hash to url
                            window.location.hash = albumId;

                            // Remove loader
                            document.querySelector('.simple-page-loader-wrapper').remove();
                        }, 255);
                    });
            });
        });
    }

    function initAlbumsGridScripts(mainContainer) {
        // Albums Photos Masonry
        var elem = document.querySelector('.images-grid.grid');

        if (elem) {
            imagesLoaded(elem, function () {
                // init Masonry after all images have loaded
                // element argument can be a selector string
                //   for an individual element
                new Masonry(elem, {
                    gutter: '.gutter-sizer',
                });

                setTimeout(() => {
                    GLightbox({
                        selector: '.glightbox3',
                        preload: true,
                    });

                    // Fade in main container
                    mainContainer.classList.remove('fade-out');

                    setTimeout(() => {
                        GLightbox({
                            selector: '.glightbox3',
                            preload: true,
                        });
                    }, 1455);

                    const loadMoreBtn = document.querySelector('.load-more button');

                    if (!loadMoreBtn) {
                        return;
                    }

                    loadMoreBtn.addEventListener('click', (e) => {
                        e.preventDefault();

                        const loadMoreUrl = loadMoreBtn.getAttribute('data-load-more-url');
                        const loadMoreContainer = loadMoreBtn.getAttribute('data-load-more');
                        const loadMoreOffset = loadMoreBtn.getAttribute('data-load-more-offset');
                        const loadMoreToal = loadMoreBtn.getAttribute('data-load-more-total');
                        const loadMoreLimit = loadMoreBtn.getAttribute('data-load-more-limit');

                        // Add loader after main container
                        mainContainer.insertAdjacentHTML('afterend', LOADER);
                        loadMoreBtn.classList.add('is-loading');
                        loadMoreBtn.setAttribute('disabled', 'disabled');

                        // Fetch album content
                        fetch(`${loadMoreUrl}?offset=${loadMoreOffset}`)
                            .then((response) => response.text())
                            .then((html) => {
                                // Create a new document
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(html, 'text/html');

                                // Get album content
                                const albumContent = doc.querySelector(loadMoreContainer);

                                // Replace main container content
                                mainContainer.querySelector('.images-grid.grid').innerHTML +=
                                    albumContent.innerHTML;

                                // Remove loader
                                document.querySelector('.simple-page-loader-wrapper').remove();

                                // Update load more offset
                                loadMoreBtn.setAttribute(
                                    'data-load-more-offset',
                                    parseInt(loadMoreOffset) + parseInt(loadMoreLimit)
                                );

                                if (
                                    parseInt(loadMoreOffset) + parseInt(loadMoreLimit) >=
                                    parseInt(loadMoreToal)
                                ) {
                                    loadMoreBtn.remove();
                                } else {
                                    loadMoreBtn.classList.remove('is-loading');
                                    loadMoreBtn.removeAttribute('disabled');
                                }

                                // Init album photos
                                setTimeout(() => {
                                    initAlbumsGridScripts(mainContainer);
                                    initAos();
                                }, 255);
                            });
                    });
                }, 1000);
            });
        }
    }

    function initPageModulesScripts() {
        initOngletsNav();
        initGrillesDeCours();
        initFiches();
        initLecteurVideo();
        initNavigationSurPageImage();
        initFlickitySliders();
        initAos();
    }
}
